import { IRebateProgressData } from "@app/account/account.models";
import { ngStoreCacheItem } from "@app/shared/helpers";
import { EntityState } from "@ngrx/entity";
import { addDays, differenceInHours, differenceInMinutes } from "date-fns";
import { RebateProgressActions, RebateProgressActionTypes } from "./rebate-progress.actions";
import { rebateProgressAdapter } from "./rebate-progress.adapter";

export interface IRebateProgressState extends EntityState<IRebateProgressData> { }

export const initialState: IRebateProgressState = rebateProgressAdapter.getInitialState();

export function rebateProgressReducer(
	state = initialState,
	action: RebateProgressActions
): IRebateProgressState {
	switch (action.type) {
		case RebateProgressActionTypes.LoadRebateProgressSuccess:
			let item: IRebateProgressData;
			const staleDate = addDays(action.payload.lastUpdated, 1);
			if (differenceInHours(staleDate, new Date()) > 6) {
				item = ngStoreCacheItem(action.payload, 6, "hours");
			} else {
				// If we are closing in on the 24 hour refresh period reduce the cache window
				const minutes = Math.max(differenceInMinutes(staleDate, new Date()), 20);
				item = ngStoreCacheItem(action.payload, minutes, "minutes");
			}
			return rebateProgressAdapter.upsertOne(item, state);
		default:
			return state;
	}
}